document.addEventListener("removeDateUsingToken",async() => {
  const checkoutReq = await fetch(`/checkout.json`);
  const checkoutReqRes = await checkoutReq.text();
  const html = new DOMParser().parseFromString(checkoutReqRes, 'text/html');
  const fetchToken = html.querySelector("meta[name='serialized-checkout-session-identifier']")?.content;
  if(!fetchToken) return;
  const token = fetchToken.substring(1, fetchToken.length-1);

  const removeTokenReq = await fetch(`https://ship.heirloomroses.com/api/remove-date?token=${token}`,{
    method: 'DELETE'
  });
  const removeTokenReqRes = await removeTokenReq.json();
});